/**
 * Плагин, который добавляет глобальный mixin для установки
 * специальных атрибутов на иконки (`<i class="v-icon">`).
 *
 * После монтирования любого Vue-компонента выполняется проход
 * по всем элементам с классом `v-icon`, и каждому из них задаются:
 * - `aria-hidden="true"` — скрывает иконку от технологий экранного доступа,
 *   так как её значение носит декоративный характер;
 * - `translate="no"` — предотвращает автоматический перевод содержимого иконки.
 */
export default {
	install(Vue) {
		Vue.mixin({
			mounted() {
				this.$nextTick(() => {
					const icons = document.querySelectorAll('i.v-icon')
					icons.forEach(icon => {
						icon.setAttribute('aria-hidden', 'true')
						icon.setAttribute('translate', 'no')
					})
				})
			}
		})
	}
}
